import moment from 'moment'
import convertNumberToCurrency from '../convertNumberToCurrency'
import { CAR_STATE, CAR_STATUS,CAR_VERIFICATION_STATUS } from '../dictionaries/car'
import { VERIFICATION_STATE } from "@/utils/dictionaries/carForm"
import { isAfter } from '@/utils/time/isAfter'
import _ from 'lodash'
/**
 * Check car is ended.
 *
 * @param {object} params
 * @param {object} params.endDate
 * @returns {boolean} isEndedCar
*/
export function isEndedCar ({ endDate }) {
  return endDate && !moment(endDate).isAfter()
}

export function getCarEndDate ({ endDate, format =  'YYYY-MM-DD hh:mm'}) {
  return endDate && moment(endDate).format(format)
}

export function getCarStartDate ({ startDate, format = 'YYYY-MM-DD hh:mm' }) {
  return startDate && moment(startDate).format(format)
}

export function getCarCreatedDate ({ createdAt, endDate, format = 'YYYY-MM-DD hh:mm' }) {
  return endDate ? moment(endDate).format(format) : createdAt ? moment(createdAt).format(format) : null
}

export function isReversePriceNotMeet({ endDate, reserve, bids, reserveValue }) {
  const reserveValueNumber = Number(reserveValue)
  if (
    !isEndedCar({ endDate }) || 
    !reserve || 
    typeof reserveValueNumber !== 'number') return

  const lastBid = getLastCarBid({ bids }, false)

  return lastBid < reserveValueNumber
}

export function isZeroBids({ bids, endDate }) {
  const lastBid = getLastCarBid({ bids }, false)
  return isEndedCar({ endDate }) && lastBid === 0
}

/**
 * Cheack car is not started and not verified.
 *
 * @param {object} car
 * @param {string} car.startDate
 * @param {number} car.verified
 */
export function isNotStarted ({ startDate }) {
  return moment(startDate).isAfter()
}

/**
 * Get last car bid.
 *
 * @param {object} params
 * @param {array} params.bids
 * @param {boolean} [convert=true]
 * @returns {number | string}
 */
export function getLastCarBid ({ bids }, convert = true) {
  if (!bids) return 0
  let sortedBid = bids;
  if(sortedBid.length > 0){
    sortedBid = _.orderBy(bids, 'id');
  }

  let value = sortedBid.length > 0 ? [...sortedBid].reverse()[0].bid : 0
  value = convert ? convertNumberToCurrency(value) : value
  return value
}

export function parseCarToForm(car) {
  return { ...car }
}

export function getStatus({ verified, startDate, endDate, status }) {
  if (moment().isBefore(startDate) && moment().isBefore(endDate)) return CAR_STATUS.Awaiting
  if (moment().isAfter(endDate)) return CAR_STATUS.Ended
  if (status === CAR_STATE.Pause) return CAR_STATUS.Pause
  if (moment().isAfter(startDate)) return CAR_STATUS.Progress
}

export function getState({ status }) {
  return status
}

export function getVerificationState({ verificationState, verified, isMarketplace = false }) {
  if(isMarketplace && verified){
    return 'Active'
  }
  else if(isMarketplace && !verified){
    return 'In Active'
  }
  if (verified) return 'Auction'

  switch (verificationState) {
    case VERIFICATION_STATE.APPLICATION: return 'Application'
    case VERIFICATION_STATE.SCHEDULING: return 'Scheduling'
    case VERIFICATION_STATE.PAYMENT: return 'Payment'
    case VERIFICATION_STATE.DONE: return 'Auction'
    case VERIFICATION_STATE.DENY: return 'Application'
    default: return 'Application'
  }
}

export function getVerificationStatus({ verificationState, verifiedById }) {
  if (verificationState === VERIFICATION_STATE.DENY) return 'declined'
  if (verifiedById && verificationState !== VERIFICATION_STATE.APPLICATION) return 'approved'
  return ''
}

export function getVerficationStateColor({ verificationState, verified }) {
  if (verified) return 'success'

  switch (verificationState) {
    case VERIFICATION_STATE.APPLICATION: return 'secondary'
    case VERIFICATION_STATE.SCHEDULING: return 'warning'
    case VERIFICATION_STATE.PAYMENT: return 'info'
    case VERIFICATION_STATE.DONE: return 'success'
    case VERIFICATION_STATE.DENY: return 'secondary'
    default: return 'secondary'
  }
}

export function getStatusColor(status) {
  switch (status) {
    case CAR_STATUS.Ended: return 'danger'
    case CAR_STATUS.Progress: return 'success'
    case CAR_STATUS.Pause: return 'secondary'
    default: return 'primary'
  }
}